export enum events {
  VIEW_WATCHES = "view_watches",
}
